// src/lib/dnd.tsx
import React from 'react';
import {
  DroppableProps,
  DraggableProps,
  DragDropContextProps,
  DragDropContext as DBCBase,
  Droppable as DroppableBase,
  Draggable as DraggableBase,
} from '@hello-pangea/dnd';

// Re-export the OnDragEndResponder type for consumers
export type OnDragEndResponder = DragDropContextProps['onDragEnd'];

// Wrap the original exports in React.ComponentType to satisfy JSX typing
const DBC = DBCBase as unknown as React.ComponentType<DragDropContextProps>;
const DroppableC = DroppableBase as unknown as React.ComponentType<DroppableProps>;
const DraggableC = DraggableBase as unknown as React.ComponentType<DraggableProps>;

export const DragDropContext: React.FC<DragDropContextProps> = (props) => <DBC {...props} />;

export const Droppable: React.FC<DroppableProps> = (props) => <DroppableC {...props} />;

export const Draggable: React.FC<DraggableProps> = (props) => <DraggableC {...props} />;
